const getUnidadesExaustor = () => {
    const url = `${process.env.REACT_APP_SERVER_IP}/GetUnidades`;
    console.log(url)
    return fetch(url)
        .then(response => response.json())
        .then(data => {
            return data; // Retorna os dados diretamente
        })
        .catch(error => {
            console.error("Erro na requisição HTTP GET:", error);
            return []; // Retorna um array vazio em caso de erro
        });
};

export default getUnidadesExaustor;